module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_16.ee310ef0.jpg";